import { ApolloClient, createHttpLink, InMemoryCache, ApolloLink } from '@apollo/client/core'
import { readCookie } from '@outputinc/o-logins'
import { useRecaptchaStore } from '@/store/RecaptchaStore'
const tokenCookieName = import.meta.env.VITE_OUTPUT_TOKEN_COOKIE_NAME

const authLink = new ApolloLink((operation, forward) => {
  const headers: Record<string, string> = {}
  const { removeRecaptcha, recaptchaToken } = useRecaptchaStore()
  const token = readCookie(tokenCookieName, false)

  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  if (recaptchaToken) {
    headers['x-ocaptcha'] = recaptchaToken
    removeRecaptcha()
  }

  headers['Content-Type'] = 'application/json'

  operation.setContext({
    headers
  })

  return forward(operation)
})

// HTTP connection to the API
const httpLink = createHttpLink({
  uri: `${import.meta.env.VITE_ROAD_MANAGER_BASE_URL}/rmquery`
})

const cache = new InMemoryCache()
const link = authLink.concat(httpLink)

export const apolloClient = new ApolloClient({
  cache,
  link,
  defaultOptions: {
    query: {
      errorPolicy: 'all'
    },
    mutate: {
      errorPolicy: 'all'
    }
  },
  connectToDevTools: import.meta.env.VITE_OUTPUT_ENVIRONMENT !== 'production'
})
